import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tenure.reducer';

export const TenureDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tenureEntity = useAppSelector(state => state.tenure.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tenureDetailsHeading">
          <Translate contentKey="apiLocationApp.tenure.detail.title">Tenure</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{tenureEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.tenure.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{tenureEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.tenure.date">Date</Translate>
            </span>
          </dt>
          <dd>{tenureEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.tenure.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{tenureEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.tenure.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{tenureEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllHouseholds">
              <Translate contentKey="apiLocationApp.tenure.totalAllHouseholds">Total All Households</Translate>
            </span>
          </dt>
          <dd>{tenureEntity.totalAllHouseholds}</dd>
          <dt>
            <span id="ownedOutright">
              <Translate contentKey="apiLocationApp.tenure.ownedOutright">Owned Outright</Translate>
            </span>
          </dt>
          <dd>{tenureEntity.ownedOutright}</dd>
          <dt>
            <span id="ownedMortgageLoan">
              <Translate contentKey="apiLocationApp.tenure.ownedMortgageLoan">Owned Mortgage Loan</Translate>
            </span>
          </dt>
          <dd>{tenureEntity.ownedMortgageLoan}</dd>
          <dt>
            <span id="sharedOwnership">
              <Translate contentKey="apiLocationApp.tenure.sharedOwnership">Shared Ownership</Translate>
            </span>
          </dt>
          <dd>{tenureEntity.sharedOwnership}</dd>
          <dt>
            <span id="socialRentedCouncil">
              <Translate contentKey="apiLocationApp.tenure.socialRentedCouncil">Social Rented Council</Translate>
            </span>
          </dt>
          <dd>{tenureEntity.socialRentedCouncil}</dd>
          <dt>
            <span id="socialRentedOther">
              <Translate contentKey="apiLocationApp.tenure.socialRentedOther">Social Rented Other</Translate>
            </span>
          </dt>
          <dd>{tenureEntity.socialRentedOther}</dd>
          <dt>
            <span id="privateRented">
              <Translate contentKey="apiLocationApp.tenure.privateRented">Private Rented</Translate>
            </span>
          </dt>
          <dd>{tenureEntity.privateRented}</dd>
          <dt>
            <span id="livesRentFree">
              <Translate contentKey="apiLocationApp.tenure.livesRentFree">Lives Rent Free</Translate>
            </span>
          </dt>
          <dd>{tenureEntity.livesRentFree}</dd>
        </dl>
        <Button tag={Link} to="/tenure" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tenure/${tenureEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TenureDetail;
